import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AdminService } from '../../../services/admin.service';
import { ExNotificationsService } from '../ex-notifications.service';

@Component({
  selector: 'app-ex-notifications-list',
  templateUrl: './ex-notifications-list.component.html',
  styleUrls: ['./ex-notifications-list.component.css']
})
export class ExNotificationsListComponent implements OnInit {
  reuaredActionList: any[] = [];
  isLoaded = false;

  constructor(private router: Router,
    private adminService: AdminService,
    private exNotificationsService: ExNotificationsService,
    private userService: UserService) {
  }

  ngOnInit() {
    this.isLoaded = false;

    this.exNotificationsService.getExNotifications().subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.reuaredActionList = res.body;

          if (this.reuaredActionList.length > 0) {
            this.renameTypes(this.reuaredActionList);
          } else {
            this.exNotificationsService.setExNotificationsList(null);
            this.router.navigate(['/signin']);
          }
        } else {
          this.exNotificationsService.setExNotificationsList(null);
          this.router.navigate(['/signin']);
          this.isLoaded = true;
        }
      },
      () => {
        this.reuaredActionList = [];
      }
    );
  }

  renameTypes(actionList) {
    if (actionList.length > 0) {
      actionList.forEach(i => {
        if (i.type === 'CONFIRMATION_STARTED') {
          i.type = 'CONFIRMATION STARTED';
        } else if (i.type === 'MODIFY_REQUEST') {
          i.type = 'MODIFY REQUEST';
        } else if (i.type === 'CONFIRMATION_FINISHED') {
          i.type = 'CONFIRMATION FINISHED';
        } else if (i.type === 'CONF_CHAT_MESSAGE') {
          i.type = 'NEW MESSAGE';
        } else if (i.type === 'FAMILIARIZATION_STARTED') {
          i.type = 'FAMILIARIZATION STARTED';
        } else if (i.type === 'FAMILIARIZATION_FINISHED') {
          i.type = 'FAMILIARIZATION FINISHED';
        } else if (i.type === 'MODIFICATION_DONE') {
          i.type = 'MODIFICATION DONE';
        } else if (i.type === 'TESTING_STARTED') {
          i.type = 'TESTING STARTED';
        } else if (i.type === 'ADDED_SUGGESTION_FOR_REVIEW') {
          i.type = 'ADDED SUGGESTION FOR REVIEW';
        } else if (i.type === 'SUGGESTION_CANCELLED') {
          i.type = 'SUGGESTION CANCELLED';
        } else if (i.type === 'SUGGESTION_IMPLEMENTED') {
          i.type = 'SUGGESTION IMPLEMENTED';
        } else if (i.type === 'SUGGESTION_POSTPONED') {
          i.type = 'SUGGESTION POSTPONED';
        } else if (i.type === 'SUGGESTION_REASSIGNED') {
          i.type = 'SUGGESTION REASSIGNED';
        } else if (i.type === 'SUGGESTION_POSTPONE_EXPIRED') {
          i.type = 'SUGGESTION POSTPONE EXPIRED';
        } else if (i.type === 'ALL_SUGGESTION_TASKS_DONE') {
          i.type = 'ALL SUGGESTION TASKS DONE';
        } else if (i.type === 'SUGGESTION_TASK_WORK') {
          i.type = 'SUGGESTION TASK WORK';
        } else if (i.type === 'SUGGESTION_TASKS_EXPIRED') {
          i.type = 'SUGGESTION TASKS EXPIRED';
        } else if (i.type === 'NEW_MESSAGE') {
          i.type = 'NEW MESSAGE';
        }
      });
      this.sortNotifications();
    } else {
      this.isLoaded = true;
    }
  }

  sortNotifications() {
    if (this.reuaredActionList.length > 0) {
      this.reuaredActionList.reverse();
      this.exNotificationsService.setExNotificationsList(this.reuaredActionList);
      this.isLoaded = true;
    }
  }

  openNotification(sID, sType, notifId) {
    switch (sType) {
      case 'CONFIRMATION STARTED':
        this.router.navigate(['/ex-notification-confirm-action/' + sID]);
        break;
      case 'FAMILIARIZATION STARTED':
        this.router.navigate(['/ex-notification-familiarize-action/' + sID]);
        break;
      case 'MODIFICATION DONE':
        this.router.navigate(['/ex-notification-confirm-action/' + sID]);
        break;
      case 'TESTING STARTED':
        this.router.navigate(['/ex-notification-familiarize-action/' + sID]);
        break;
      case 'SUGGESTION CANCELLED':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION IMPLEMENTED':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION POSTPONED':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION TASK WORK':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'NEW MESSAGE':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION POSTPONE EXPIRED':
        this.markNotify(notifId);
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'ALL SUGGESTION TASKS DONE':
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION TASKS EXPIRED':
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'ADDED SUGGESTION FOR REVIEW':
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;
      case 'SUGGESTION REASSIGNED':
        this.router.navigate(['/ex-suggestion-expired/' + sID + '/' + notifId]);
        break;

    }
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
        this.isLoaded = false;
      }
    );
  }


  setClass(type, status) {
    if (status === 'ACTIVE') {
      switch (type) {
        case 'CONFIRMATION STARTED':
          return 'notify-border-left-one';
        case 'MODIFY REQUEST':
          return 'notify-border-left-two';
        case 'CONFIRMATION FINISHED':
          return 'notify-border-left-three';
        case 'FAMILIARIZATION STARTED':
          return 'notify-border-left-five';
        case 'FAMILIARIZATION FINISHED':
          return 'notify-border-left-six';
        case 'MODIFICATION DONE':
          return 'notify-border-left-md';
        case 'TESTING STARTED':
          return 'notify-border-left-ts';
      }
    } else {
      return 'notify-border-left-inactive';
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/auth/signin/ex-notifications-list/ex-notifications-list.component.ts